import { useTranslation } from 'react-i18next';
import styled, { createGlobalStyle } from 'styled-components';
import { ColorNeutralWhite, Spacing16 } from 'autogen/design-tokens/tokens';
import images from 'autogen/images';
import { RotateAndZoom } from 'autogen/translation-keys/trans-website-shared';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Flex from 'components/Layout/components/Flex';
import dynamic from 'helpers/dynamic';
import { breakpoint, sizes } from 'variables';
import OrbitvuPlayer from './OrbitvuPlayer';

const StyledFlexColumn = styled(Flex.Column)`
    max-width: 924px;
    width: 100%;
    aspect-ratio: 1;
    margin: 0 auto;
    max-height: calc(100% - 56px);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    background-color: white;

    ${breakpoint.up(sizes.lg)} {
        max-height: calc(100% - 72px);
    }
`;

const Info360Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 924px;
    min-height: 72px;
    width: 100%;
    padding: ${Spacing16};
    background-color: ${ColorNeutralWhite};

    min-height: 56px;
    ${breakpoint.up(sizes.lg)} {
        min-height: 72px;
    }
`;

const CenterContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const GlobalOrbitvuStyling = createGlobalStyle`
    #presentation1-container {
        cursor: url("${images.cursor360}"), auto;
        position: relative;
        background-color: white;
        
        &:before {
            content: '';
            background-color: transparent;
            left: 0;
            top:0;
            height: 100%;
            width: 40px;
            position: absolute;
            display: block;
            z-index: 11;
        }

        &:after {
            content: '';
            background-color: transparent;
            right: 0;
            top:0;
            height: 100%;
            width: 40px;
            position: absolute;
            display: block;
            z-index: 11;
        }

        &-obj-ovvvport {
            background-color: transparent !important;
        }

        &-obj-canvas {
            aspect-ratio: 1;
            background-color: transparent !important;
            transform: none;
        }
    }
`;

const Arrow360Icon = dynamic(() => import('icons/Arrow360.svg?react'));

export default function Product360Player({ directoryUrl }) {
    const { t } = useTranslation();

    return (
        <CenterContainer>
            <StyledFlexColumn gap="0">
                <GlobalOrbitvuStyling />
                <OrbitvuPlayer directoryUrl={directoryUrl} />
                <Info360Container>
                    <WithIcon icon={<Arrow360Icon height={24} width={40} fill="black" />}>
                        <Typography.Body as="span" size="L">
                            {t(RotateAndZoom)}
                        </Typography.Body>
                    </WithIcon>
                </Info360Container>
            </StyledFlexColumn>
        </CenterContainer>
    );
}
